// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-component{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0;margin:0;overflow:hidden}.menu-component--vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#fff;-webkit-box-shadow:rgba(0,0,0,.04) 0 0 8px,rgba(0,0,0,.1) 0 0 4px;box-shadow:0 0 8px rgba(0,0,0,.04),0 0 4px rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
